<template>
  <span>
    <v-btn icon @click="handleShowForm">
      <v-icon small>fa-plus-circle</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Add invoice</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <client-select :rules="clientRules"
                           @selected="handleClientsAndCoastCenters"
                           />
            <div>
              <v-autocomplete
                v-if="this.isCostCenter"
                :items="this.regions"
                v-model="form.regionId"
                item-value="key"
                item-text="name"
                label="Region"
                persistent-hint
              ></v-autocomplete>
              <date-time-input
                label="From"
                :required="true"
                v-model="form.from"
                :max-datetime="form.to"
                :value-post-processor="setTimeToStartOfDay"
                :showNow="false"/>
            </div>

            <div>
              <date-time-input
                label="To"
                :required="true"
                :min-datetime="form.from"
                v-model="form.to"
                :value-post-processor="setTimeToEndOfDay"
                :showNow="false"/>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import ClientSelect from '../../Ui/mcc/ClientSelect'
  import {notNullFactory} from "../../../validation/rules";
  import {mapActions} from "vuex";
  import {notificationService} from "../../../application";
  import DateTimeInput from "../../Ui/DateTimeInput";
  import {setTimeToEndOfDay, setTimeToStartOfDay} from '../../../helpers/date'

  import { mapState } from 'vuex'

  function getDefaultFormData() {
    return {
      clientId: null,
      regionId: null,
      from: null,
      to: null
    }
  }

  export default {
    name: 'add-invoice-form',
    components: {
      ClientSelect,
      DateTimeInput
    },
    props: {},
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        clientRules: [notNullFactory()],
        requestInProgress: false,
        isCostCenter: false
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      ...mapState({
        regions: 'regions',
        allRegionsMap: 'allRegionsMap',
        allCostCentersMap: 'allCostCentersMap'
      }),
      isSubmitEnabled() {
        const valid = this.isValid && this.form.from && this.form.to;
        if (!valid) {
          return false
        }
        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      }
    },
    methods: {
      ...mapActions({
        invoiceCreate: 'invoiceCreate',
        createInvoiceWithCostCenters: 'createInvoiceWithCostCenters'
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      async handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        let request

        if (this.isCostCenter) {
          request = {
            costCenterId: this.form.clientId,
            regionId: this.form.regionId,
            from: this.form.from,
            to: this.form.to,
          }
        } else {
          request = {
            clientId: this.form.clientId,
            from: this.form.from,
            to: this.form.to,
          };
        }


        console.log('this.isCostCenter is: ', this.isCostCenter);
        console.log('handleFormSubmit request is: ', request);

        this.requestInProgress = true;

        try {
          await this.invoiceCreate(request)
          notificationService.info('Operation success');
          this.resetForm();
          this.showModal = false
        } catch (error) {
          this.requestInProgress = false;
          notificationService.error('Operation failed');
          throw error
          
        }
        this.requestInProgress = false;
      },
      resetForm() {
        this.form = getDefaultFormData()
      },
      setTimeToStartOfDay(value) {
        return setTimeToStartOfDay(value)
      },
      setTimeToEndOfDay(value) {
        return setTimeToEndOfDay(value)
      },
      handleClientsAndCoastCenters (value) {
        const prefix = value.substr(0, 2)

        this.form.clientId = value.slice(2)

        console.log(`prefix is: ${prefix} and this.form.clientId is: ${value.slice(2)}`);
        
        if (prefix == 'CC') {
          this.isCostCenter = true
          return
        }
        this.isCostCenter = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/AddInvoiceForm.vue